import { Text } from '@/design-system';
import { cn } from '@/design-system/utils/cn';
import { OrganizationPlanSchema } from '@/types/schema';

import { renderDaysRemaining } from '../utils/paymentPlanCard.utils';

export const PaymentPlanStatusBadge = ({
  currentPlan,
  showStatusBadge,
  isCurrentPlan,
  isUpcomingPlan,
  isApprovedPlan,
  hasCancelled,
  upcomingPlanStartedOn,
  endOfBillingPeriodFormatted,
}: {
  currentPlan: OrganizationPlanSchema | undefined;
  showStatusBadge: boolean;
  isCurrentPlan: boolean;
  isUpcomingPlan: boolean;
  isApprovedPlan: boolean;
  hasCancelled: boolean;
  upcomingPlanStartedOn: Date | null;
  endOfBillingPeriodFormatted: string | null;
}) => {
  const isNotDeveloper = currentPlan?.tier !== 'developer';

  if (!showStatusBadge) return null;

  const statusText = (() => {
    if (hasCancelled)
      return `${
        isNotDeveloper
          ? 'SUBSCRIPTION ENDS ON'
          : 'PAYMENT METHOD TO BE REMOVED ON'
      } ${endOfBillingPeriodFormatted}`;

    if (isCurrentPlan) return 'CURRENT PLAN';
    if (isUpcomingPlan)
      return `UPCOMING PLAN ${
        upcomingPlanStartedOn
          ? `- STARTS IN ${renderDaysRemaining(upcomingPlanStartedOn)}`
          : ''
      }`;
    if (isApprovedPlan) return 'YOU ARE APPROVED. ACTIVATE NOW';
    return '';
  })();

  return (
    <Text
      variant="xs"
      weight="semibold"
      className={cn('p-2 text-center uppercase', {
        'text-purple': !hasCancelled,
        'text-error': hasCancelled,
      })}
    >
      {statusText}
    </Text>
  );
};
